import { c as _c } from "react/compiler-runtime";
import { PopularBadge } from "@/components/ui/popular-badge";
import QuantityStepper from "@/components/ui/quantity-stepper";
import { TelehealthBadge } from "@/components/ui/telehealth-badge";
import { useCatalogImageLayout } from "@/contexts/catalog-image-layout-provider";
import { cx } from "@/lib/tailwind-utils";
import { PublicServiceDetail } from "@/types/service";
import { AddonsAvailableBadge, DisabledBadge, InfoButton, PromotionBadge, ServiceDescription, ServiceTitle } from "./components";
import { BookingFeeNote, PriceDisplay, PricingInfo } from "./price-display";
import { SelectionCircle } from "./selection-circle";
interface ServiceMenuItemMobileProps {
  standalone?: boolean;
  collapsibleDescription?: boolean;
  service: PublicServiceDetail;
  isSelected: boolean;
  selectionCount?: number;
  maxQuantity?: number;
  disabled: boolean;
  onQuantityChange?: (serviceId: string, quantity: number) => void;
  showBookingFee: boolean;
  bookingFee: number;
  pricing: PricingInfo;
  onInfoClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  hasAddons?: boolean;
  durationMin?: number;
  durationMax?: number;
  showDuration?: boolean;
  pricePrefix?: string;
}
export const ServiceMenuItemMobile = t0 => {
  const $ = _c(62);
  const {
    service,
    isSelected,
    selectionCount: t1,
    maxQuantity,
    disabled,
    onQuantityChange,
    showBookingFee,
    bookingFee,
    pricing,
    onInfoClick,
    hasAddons,
    durationMin,
    durationMax,
    standalone: t2,
    collapsibleDescription: t3,
    showDuration: t4,
    pricePrefix
  } = t0;
  const selectionCount = t1 === undefined ? 0 : t1;
  const standalone = t2 === undefined ? false : t2;
  const collapsibleDescription = t3 === undefined ? false : t3;
  const showDuration = t4 === undefined ? true : t4;
  const {
    catalogImageLayout
  } = useCatalogImageLayout();
  const usesSquareImage = catalogImageLayout === "SQUARE";
  let t5;
  if ($[0] !== service.name) {
    t5 = <ServiceTitle name={service.name} className="line-clamp-3 leading-snug" />;
    $[0] = service.name;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== service.isPopular) {
    t6 = service.isPopular && <PopularBadge />;
    $[2] = service.isPopular;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== service.promotionName) {
    t7 = service.promotionName && <PromotionBadge promotionName={service.promotionName} />;
    $[4] = service.promotionName;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = <div className="mt-1 flex flex-wrap items-center gap-1.5">{t6}{t7}</div>;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t5 || $[10] !== t8) {
    t9 = <div className="flex-1 min-w-0">{t5}{t8}</div>;
    $[9] = t5;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isSelected || $[13] !== maxQuantity || $[14] !== onQuantityChange || $[15] !== selectionCount || $[16] !== service.allowMultipleBookings || $[17] !== service.id) {
    t10 = isSelected && service.allowMultipleBookings && onQuantityChange ? <div onClick={_temp}><QuantityStepper value={selectionCount} min={0} max={maxQuantity} onChange={quantity => onQuantityChange(service.id, quantity)} className="shadow-sm" /></div> : <SelectionCircle isSelected={isSelected} count={selectionCount} className="mt-0.5" />;
    $[12] = isSelected;
    $[13] = maxQuantity;
    $[14] = onQuantityChange;
    $[15] = selectionCount;
    $[16] = service.allowMultipleBookings;
    $[17] = service.id;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="flex items-start justify-between gap-3">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== service.isVirtual) {
    t12 = service.isVirtual && <TelehealthBadge className="mt-1" />;
    $[22] = service.isVirtual;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== hasAddons) {
    t13 = hasAddons && <AddonsAvailableBadge className="mt-1" />;
    $[24] = hasAddons;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = durationMin ?? service.duration;
  let t15;
  if ($[26] !== bookingFee || $[27] !== durationMax || $[28] !== pricePrefix || $[29] !== pricing || $[30] !== service.bookingFeeAutoToCredit || $[31] !== showBookingFee || $[32] !== showDuration || $[33] !== t14) {
    t15 = <PriceDisplay pricing={pricing} bookingFee={bookingFee} showBookingFee={showBookingFee} bookingFeeAutoToCredit={service.bookingFeeAutoToCredit} duration={t14} durationMax={durationMax} showDuration={showDuration} prefix={pricePrefix} variant="mobile" />;
    $[26] = bookingFee;
    $[27] = durationMax;
    $[28] = pricePrefix;
    $[29] = pricing;
    $[30] = service.bookingFeeAutoToCredit;
    $[31] = showBookingFee;
    $[32] = showDuration;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== bookingFee || $[36] !== service.bookingFeeAutoToCredit || $[37] !== service.displayPrice || $[38] !== showBookingFee) {
    t16 = <BookingFeeNote showBookingFee={showBookingFee} displayPrice={service.displayPrice} bookingFee={bookingFee} bookingFeeAutoToCredit={service.bookingFeeAutoToCredit} variant="mobile" />;
    $[35] = bookingFee;
    $[36] = service.bookingFeeAutoToCredit;
    $[37] = service.displayPrice;
    $[38] = showBookingFee;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t15 || $[41] !== t16) {
    t17 = <div className="flex items-center gap-3 mt-1.5">{t15}{t16}</div>;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== collapsibleDescription || $[44] !== service.description || $[45] !== standalone) {
    t18 = service.description && <ServiceDescription description={service.description} standalone={standalone} collapsible={collapsibleDescription} className="mt-2" />;
    $[43] = collapsibleDescription;
    $[44] = service.description;
    $[45] = standalone;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== disabled || $[48] !== onInfoClick) {
    t19 = (disabled || onInfoClick) && <div className="flex items-center justify-between mt-2">{disabled ? <DisabledBadge /> : onInfoClick && <InfoButton onClick={onInfoClick} />}</div>;
    $[47] = disabled;
    $[48] = onInfoClick;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t11 || $[51] !== t12 || $[52] !== t13 || $[53] !== t17 || $[54] !== t18 || $[55] !== t19) {
    t20 = <div className="min-w-0 flex-1">{t11}{t12}{t13}{t17}{t18}{t19}</div>;
    $[50] = t11;
    $[51] = t12;
    $[52] = t13;
    $[53] = t17;
    $[54] = t18;
    $[55] = t19;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  const body = t20;
  let t21;
  if ($[57] !== body || $[58] !== service.image || $[59] !== service.name || $[60] !== usesSquareImage) {
    t21 = <div className="md:hidden">{service.image ? <div className="flex items-start gap-3"><img src={service.image} alt={service.name} className={cx("flex-shrink-0 rounded-lg", usesSquareImage ? "aspect-square w-20 bg-background object-contain" : "aspect-video w-24 object-cover")} />{body}</div> : body}</div>;
    $[57] = body;
    $[58] = service.image;
    $[59] = service.name;
    $[60] = usesSquareImage;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  return t21;
};
function _temp(event) {
  return event.stopPropagation();
}